/**
 * alias for parseInt(num, 10)
 *
 * @documented
 * @category Number
 *
 * @param {String} num
 * @returns {Number}
 * @example
 *
 *		parseInt10('10') // => 10
 *
 */ const parseInt10 = (num)=>parseInt(num, 10);
export default parseInt10;
